 
import { Entity } from './entity';
import { Department } from './department';

export class Region extends Entity {
    public id: number;
    public name: string;
    public department: Department[];
  }  